//------------------------------------------------------------------------
// Main nav submenus
//------------------------------------------------------------------------
import ExpandToggle from '@threespot/expand-toggle';

export default class subnavMenus {
  constructor() {
    this.toggles = document.querySelectorAll('.Nav-toggle');
    this.expandables = [];// placeholder
    this.allowMultipleOpen = true;// allow multiple in mobile
    this.subnavToggleEvent = new CustomEvent('subnav-toggle');

    // Nav breakpoint should match $layout-nav-bp in _layout-vars.scss
    this.mediaQueryList = window.matchMedia('(min-width: 1095px)');

    // Listen for breakpoint change, update behavior
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.allowMultipleOpen = false;
      } else {
        this.allowMultipleOpen = true;
      }
    });

    // Update behavior on load
    if (this.mediaQueryList.matches) {
      this.allowMultipleOpen = false;
    }

    // Init toggles
    this.toggles.forEach(el => {
      let toggle = new ExpandToggle(el);
      this.expandables.push(toggle);

      // Emit “subnav-toggle” event to update mobile nav dropdown height
      toggle.on('expand', () => {
        document.documentElement.dispatchEvent(this.subnavToggleEvent);
      });

      toggle.on('collapse', () => {
        document.documentElement.dispatchEvent(this.subnavToggleEvent);
      });
    });

    // Collapse toggle when switching between mobile and desktop nav layout
    document.documentElement.addEventListener('nav-reset', () => {
      this.expandables.forEach(toggle => {
        toggle.collapse();
      });
    });

    // Update height when web fonts have loaded
    document.documentElement.addEventListener('fonts-loaded', () => {
      this.expandables.forEach(toggle => {
        toggle.updateExpandedHeight();
      });
    });

    // Close toggles if click outside of them
    window.addEventListener('click', evt => {
      if (!this.allowMultipleOpen && !evt.target.closest('.Nav-item.has-menu')) {
        this.closeMenus();
      }
    });

    // Logic to check if only one menu should be open at a time
    this.expandables.forEach((currToggle, currindex) => {
      // Add “expand” event listener to toggles
      // (has to be done after “this.expandables” array has been populated)
      currToggle.on('expand', () => {
        if (!this.allowMultipleOpen) {
          // Close other menus
          this.expandables.forEach((toggle, index) => {
            if (index !== currindex) {
              toggle.collapse();
            }
          });
        }
      });
    });
  }

  closeMenus() {
    this.expandables.forEach(toggle => {
      toggle.collapse();
    });
  }
}

// Init
new subnavMenus();